'use client';

import { useMemo } from 'react';
import { useSnapshot } from 'valtio';

import { checkoutState } from '@/states/checkout/checkoutState';

import { isOrderCreateShoppingBagErrorCode } from './orderCreateShoppingBagErrorCodes';
import {
  parseShoppingBagLineErrors,
  type ShoppingBagLineErrors,
} from './parseShoppingBagLineErrors';

/** Line-level CPI / stock messages from checkout `apiErrors` (payment step order review). */
export function useCheckoutShoppingBagLineErrors(): ShoppingBagLineErrors {
  const { apiErrors } = useSnapshot(checkoutState);

  return useMemo(() => {
    const shoppingBagErrors = (apiErrors ?? []).filter(
      (error) => error.type === 'orderApp' && isOrderCreateShoppingBagErrorCode(error.code)
    );
    return parseShoppingBagLineErrors(shoppingBagErrors);
  }, [apiErrors]);
}
